export function toSafeUiMessage(err: any): string {
  const status = err?.status ?? err?.error?.status
  if (status === 400) return 'Invalid request. Please check your input.'
  if (status === 401 || status === 403) return 'You are not authorized to do that.'
  if (status === 404) return 'Requested resource was not found.'
  if (status === 409) return 'Request conflicted with existing data.'
  if (status === 429) return 'Too many requests. Please try again later.'
  if (typeof status === 'number' && status >= 500) {
    return 'Server error. Please try again later.'
  }

  const raw =
    err?.error?.message ??
    err?.error?.error?.message ??
    err?.message ??
    'Unexpected error. Please try again.'

  let msg = String(raw)
    .replace(/[\u0000-\u001F\u007F]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

  if (!msg) msg = 'Unexpected error. Please try again.'
  if (msg.length > 160) msg = `${msg.slice(0, 160)}…`

  return msg
}
